import { render, staticRenderFns } from "./ManagementAreasList.vue?vue&type=template&id=4a43ade9&scoped=true"
import script from "./ManagementAreasList.vue?vue&type=script&lang=ts"
export * from "./ManagementAreasList.vue?vue&type=script&lang=ts"
import style0 from "./ManagementAreasList.vue?vue&type=style&index=0&id=4a43ade9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a43ade9",
  null
  
)

export default component.exports